import { createApp } from 'vue'
import VueNavigationBar from 'vue-navigation-bar';
import 'vue-navigation-bar/dist/vue-navigation-bar.css';
import App from './App.vue'
import { createRouter, createWebHashHistory} from 'vue-router'

import AcademicsView from './views/AcademicsView.vue'
import ProjectsView from './views/ProjectsView.vue'
import HomeView from './views/HomeView.vue'
import CareerView from './views/CareerView.vue';

const app = createApp(App);

app.component('vue-navigation-bar', VueNavigationBar);

const router = createRouter({  
    history: createWebHashHistory(),
    routes: [
      { path: '/', component: HomeView },
      { path: '/career', component: CareerView },
      { path: '/projects', component: ProjectsView },
      { path: '/academics', component: AcademicsView },
  
      // Not found
      /* { path: '/*', component: NotFound } */
    ]
})

app.use(router);
app.mount('#app');